export default function ContactBlock({ office }) {
  return (
    <div
      className="border border-ink-700 p-8 hover-lift"
      data-testid={`contact-${office.name.toLowerCase().split(" ")[0]}`}
    >
      <p className="overline mb-3">{office.name}</p>
      <p className="font-display font-bold text-xl mb-3">{office.person}</p>
      <p className="font-mono text-xs text-textmuted leading-relaxed mb-5">{office.address}</p>
      {office.emails && (
        <ul className="font-mono text-xs space-y-1 mb-3">
          {office.emails.map((e) => (
            <li key={e}>
              <a href={`mailto:${e}`} className="text-textmain hover:text-signal-amber transition-colors">
                {e}
              </a>
            </li>
          ))}
        </ul>
      )}
      <ul className="font-mono text-xs space-y-1">
        {office.phones.map((p) => (
          <li key={p}>
            <a href={`tel:${p.replace(/\s/g, "")}`} className="text-textmain hover:text-signal-amber transition-colors">
              {p}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
